import { AgeProps } from '../dto/ageDTO';

import girl11 from '~/assets/images/girl11.png';
import boy12 from '~/assets/images/boy12.png';
import boy15 from '~/assets/images/boy15.png';
import age11 from '~/assets/images/age11.png';
import boy from '~/assets/images/boy.png';
import girl from '~/assets/images/girl.png';
import woman from '~/assets/images/woman.png';
import man from '~/assets/images/man.png';
import age10 from '~/assets/images/age10.png';
import age18 from '~/assets/images/age18.png';
import age35 from '~/assets/images/age35.png';
import age45 from '~/assets/images/age45.png';

const teenAges: AgeProps[] = [ {
  id: '<11',
  title: '< 11',
  image: girl11,
  finalImage: age11,
}, {
  id: '12-14',
  title: '12-14',
  image: boy12,
  finalImage: age11,
}, {
  id: '15-17',
  title: '15-17',
  image: boy15,
  finalImage: age11,
} ];

const adultAges: AgeProps[] = [ {
  id: '10-17',
  title: '10-17',
  image: boy,
  finalImage: age10,
}, {
  id: '18-34',
  title: '18-34',
  image: girl,
  finalImage: age18,
}, {
  id: '35-44',
  title: '35-44',
  image: woman,
  finalImage: age35,
}, {
  id: '45+',
  title: '45+',
  image: man,
  finalImage: age45,
} ];

export default {
  parent: teenAges,
  adult: adultAges,
};
